import React, { PureComponent } from 'react';
import styled from "styled-components";
import Sizes from "../Assets/Sizes";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { humanizeDayOfWeek, serverShortTime, serverDayDate } from "../Common/Helpers";

const InstantOptions = styled.div`
	position: relative;
	width: 100%;
	white-space: nowrap;
	> button:not(:first-of-type) {
		margin-right: ${ Sizes.mediumPadding };
	}
	
	.fade-enter {
	  opacity: 0;
	  transform: translateX(30px);
	}
	
	.fade-enter-active {
	  opacity: 1;
	  transform: translateX(0);
	  
	  transition: all 500ms;
	}
	
	.fade-exit {
	  opacity: 1;
	  transform: translateX(0);
	}
	
	.fade-exit-active {
	  transform: translateX(30px);
	  opacity: 0;
	  transition: all 500ms;
	}
`;

const Item = styled.button`
    white-space: nowrap;
	display:inline-block;
	box-shadow: ${ p => p.theme.colors.defaultBoxShadow };
    border: none;
    border-radius: 50%;
    background: ${ p => p.theme.colors.surfaceFront };
    text-align: right;
    text-align: start;
    color: ${ p => p.theme.colors.primaryText };
    height: ${ Sizes.instantOptionsSize };
    width: ${ Sizes.instantOptionsSize };
    -webkit-user-select: none; /* Chrome all / Safari all */
    -moz-user-select: none;   /* Firefox all */
    -ms-user-select: none;  /* IE 10+ */
    user-select: none;  /* Likely future */
    text-align: center;
`;

const SelectItemLabel = styled.div`
	font-weight: bold;
`;

const TimeLabel = styled.span`
	font-size: 1.15rem;	
`;

const Small = styled.div`
	font-size: 0.7rem;
`;
export default class InstantOptionsComponent extends PureComponent {
	state = { items: [] };

	componentDidMount() {
		if (this.props.items) {
			this.setState({ items: this.props.items });
		}
	}

	componentWillReceiveProps(nextProps, nextContext) {
		if (nextProps.items) {
			this.setState({ items: nextProps.items });
		}
	}

	render() {
		const items = this.state.items.map((item, idx) => {
			const delay = Math.max(0, idx * 50);
			// const day = serverDate(item.Start);
			const time = serverShortTime(item.Start);
			const date = serverDayDate(item.Start);

			return (<CSSTransition
				timeout={ 500 + delay }
				classNames="fade"
				key={ idx }>
				<Item onClick={ () => this.props.itemSelected(item) }
					  selected={ item === this.props.selected }
					  style={ { 'transitionDelay': `${ delay }ms` } }>
					<div>
						<SelectItemLabel { ...item }>{ humanizeDayOfWeek(item.Start) }</SelectItemLabel>
						<TimeLabel>{ time }</TimeLabel>
						<Small>{ date }</Small>
					</div>
				</Item>
			</CSSTransition>);
		});


		return (
			<InstantOptions>
				<TransitionGroup component={ null }>
					{ items }
				</TransitionGroup>
			</InstantOptions>
		)
	}
}

